<div #lastMessageFocus>
    <mat-card class="inbox-email-message-container !tw-p-3 tw-border tw-m-3">
        <!-- Begin Header -->
        <div class="tw-grid tw-grid-cols-4 tw-mb-1">
            <div class="tw-col-span-3 tw-flex tw-flex-row">
                <div class="tw-h-6 tw-w-6 tw-pt-1 mt-2 mr-2 text-center tw-rounded-full"
                [ngClass]="{'inbox-email-message-lendion-initials-background': isLendion, 'inbox-email-message-initials-background': !isLendion}">
                    <span class="inbox-email-message-initial-letters">{{ firstName[0] }}{{ lastName[0] }}</span>
                </div>
                <div class="tw-mt-3">
                    <span *ngIf="message.fromName" class="tw-font-semibold">{{ message.fromName }}</span>
                </div>
            </div>
            <div class="tw-col-span-1 tw-flex tw-flex-row tw-flex-nowrap float-right tw-mt-2 tw-place-content-end">
                <div *ngIf="message.attachments && message.attachments.length" class="inbox-email-message-attachment tw-mr-2">
                    <mat-icon>attachment</mat-icon>
                </div>
                <div *ngIf="message && message.createdTimestamp">
                    <span>{{ message?.createdTimestamp * 1000 | date: 'M/d/yyyy - h:mm a' }}</span>
                </div>
            </div>
        </div>
        <!-- End Header -->
        <!-- Begin Message -->
        <div>
            <div class="tw-ml-2">
                <mat-panel-description class="inbox-email-message-content tw-mb-3 tw-ml-2">
                    <div [innerHTML]="message.html"></div>
                </mat-panel-description>
            </div>
            <div *ngIf="message.attachments && message.attachments.length > 0" class="tw-flex tw-flex-wrap tw-my-7 tw-mt-4">
                <div *ngFor="let attachment of message.attachments" [ngSwitch]="attachment.filename.split('.').pop()" class="tw-mx-1">
                    <button mat-stroked-button class="inbox-email-message-attachment-button" (click)="downloadAttachment(attachment.id)">
                    <i *ngSwitchCase="'pdf'"><img src="assets/images/pdf-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <i *ngSwitchCase="'csv'"><img src="assets/images/spreadsheet-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <i *ngSwitchCase="'xls'"><img src="assets/images/spreadsheet-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <i *ngSwitchCase="'xlsx'"><img src="assets/images/spreadsheet-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <i *ngSwitchCase="'doc'"><img src="assets/images/doc-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <i *ngSwitchCase="'docx'"><img src="assets/images/doc-icon.png" class="inbox-email-message-attachment-button-icon tw-w-6 tw-h-6"></i>
                    <mat-icon *ngSwitchDefault>insert_drive_file</mat-icon>
                        {{ (attachment.filename.length < 20) ? attachment.filename : (attachment.filename | slice:0:20) + '...' }}
                    </button>
                </div>
            </div>
            <div *ngIf="message.opened" class="tw-mt-4">
                <span class="inbox-email-message-read-by-text" *ngIf="message.recipientRecords && message.recipientRecords.length === 1">
                    <span class="inbox-email-message-read">Read</span> by {{ message.recipientRecords[0].email }} <br>
                </span>
                <span class="inbox-email-message-read-by-text" *ngIf="message.recipientRecords && message.recipientRecords.length > 1">
                    <span class="inbox-email-message-read">Read</span> by {{ message.numberOfViews }} of {{ message.recipientRecords.length }} recipients<br>
                </span>
            </div>
            <div *ngIf="!messageCreateTypeValue && isLast" class="tw-flex tw-flex-row tw-flex-nowrap tw-mt-4">
                <div>
                    <button mat-stroked-button class="inbox-email-message-reply-button" [disabled]="borrower && (borrower.status === 'dead' || borrower.status === 'doNotContact')" (click)="setMessageCreateType('reply')">
                        <mat-icon class="tw-text-base">arrow_back</mat-icon>Reply
                    </button>
                </div>
                <div class="tw-ml-4">
                    <button mat-stroked-button class="inbox-email-message-forward-button" [disabled]="borrower && (borrower.status === 'dead' || borrower.status === 'doNotContact')" (click)="setMessageCreateType('forward')">
                        <mat-icon class="tw-text-base">arrow_forward</mat-icon>Forward
                    </button>
                </div>
            </div>
            <div *ngIf="message.recipientRecords && message.recipientRecords.length > 0">
                <div class="tw-mt-4 tw-flex warning-message tw-rounded tw-py-2" *ngIf="message && message.recipientRecords[0].status === 'rejected'">
                    <mat-icon class="rejected-message-icon tw-mt-2">warning</mat-icon>
                    <div>
                        <span><b>Whoops!</b> This message didn't go through. </span><br>
                        <span>Try verifying and correcting the recipient's email: <b>{{ message.recipientRecords[0].email }}</b>,
                         or contact support if your Lendio email looks incorrect: <b>{{ message.fromEmail }}</b></span>
                    </div>
                </div>
            </div>
            <mat-card *ngIf="!!messageCreateTypeValue" class="reply-forward-message tw-min-h-[200px] tw-px-2 tw-bg-white tw-border tw-mt-4">
                <app-messages-create-new
                    [borrower]="borrower"
                    [thread]="thread"
                    [user]="lenderUser?.fullName"
                    [messageType]="messageCreateTypeValue"
                    [joinedContacts]="joinedContacts"
                    (emailCreate)="handleEmailCreate.emit($event)"
                    (cancelMessage)="setMessageCreateType(null)">
                </app-messages-create-new>
            </mat-card>
        </div>
        <!-- End Message -->
    </mat-card>
</div>
